import { NgModule } from '@angular/core';

import { SharedModule } from '../../../../../shared';
import { NgxBootstrapMultiselectModule } from 'ngx-bootstrap-multiselect';

import { ClienteCadastroMultiselectComponent } from './cliente-cadastro-multiselect.component';

@NgModule({
    imports: [
        SharedModule,
        NgxBootstrapMultiselectModule
    ],
    declarations: [
        ClienteCadastroMultiselectComponent
    ],
    exports: [
        ClienteCadastroMultiselectComponent
    ]
})
export class ClienteCadastroMultiselectModule { }
